import $ from "jquery";
import InputGeral from "../InputGeral/Index"
import SelectContato from "../Select/Contato"
import { CelBreak25, CelBreakTen, CelBreak15 } from "./styles"

function handleFornecedorCodigo(item){
    const { A2_COD, A2_LOJA, A2_NOME, A2_EMAIL } = item.row.original;
    
    return (
        <>
            <p><strong>Código: </strong>{A2_COD.trim()} / <strong>Loja:</strong>{A2_LOJA.trim()}</p>
            <p><CelBreak25><strong>Nome: </strong>{A2_NOME.trim()}</CelBreak25></p>
            <p><CelBreak25><strong>E-mail: </strong>{A2_EMAIL.replace(';', ' ').trim()}</CelBreak25></p>
        </>
    )
}

function handleFornecedorTipo(item){
    const { A2_XTPFOR, PSV_DESCRI } = item.row.original;

    return (
        <>
            {PSV_DESCRI && PSV_DESCRI.trim() && (<p><strong>{A2_XTPFOR.trim()} - {PSV_DESCRI.trim()}</strong></p>)}            
        </>
    )
}

function handleFornecedorMunicipio(item){ 
    const { A2_MUN, A2_EST } = item.row.original;

    return (
        <>
            <p><CelBreak15>{A2_MUN.trim()}</CelBreak15></p>
            <p><CelBreakTen><strong>UF: </strong>{A2_EST.trim()}</CelBreakTen></p>
        </>
    )
}

function handleAvaliacao(item){ 
    const nMediaHomologado = window._env_?.REACT_APP_MEDIA_HOMOLOGACAO
    const { A2_MEDIA, A2_XTPFORN } = item.row.original;
    const cStatus = A2_XTPFORN === 'N' ? 'Não Aplicável' : ( parseFloat(A2_MEDIA) >= parseFloat(nMediaHomologado) ? 'Qualificado' : 'Não Qualificado')

    return ( <p><CelBreakTen>{cStatus}</CelBreakTen></p> )
}

function handleCheckFornecedor(e, item){
    item.data[item.row.index].Check = true;
    item.row.original.Check = true;
}

function handleCheckColumnFornecedor(item) {
    return (
        <input
            type="checkbox"
            checked={item.Check}
            onChange={(e) => handleCheckFornecedor(e, item)}
        />
    );
}

const handleHomologacaoLabel = (item) => {
    const nMediaHomologado = window._env_?.REACT_APP_MEDIA_HOMOLOGACAO
    let cStatusHomologacao = 'Não Aplicável'

    if (item.row.original.A2_XTPFORN !== 'N'){
        cStatusHomologacao = (item.row.original.A2_MEDIA >= nMediaHomologado ? 'Qualificado' : 'Não Qualificado')
    }

    return ( <span><strong>Homologação: </strong> {cStatusHomologacao}</span> )
}

const handleCardFornecedor = (item) => {
    return ( <> <p><strong>{item.value.trim()}</strong></p>
                <p><strong>CNPJ: </strong>{item.row.original.A2_CGC.trim()}</p>
                <p><strong>Município/UF: </strong> {item.row.original.A2_MUN.trim()}/{item.row.original.A2_EST.trim()}</p>
                <p>{ handleHomologacaoLabel(item) }</p>
             </> )
}

const handleHomologacao = (item) => {
    const nMediaHomologado = window._env_?.REACT_APP_MEDIA_HOMOLOGACAO
    let cStatusHomologacao = 'Não Aplicável'

    if (item.row.original.A2_XTPFORN !== 'N'){
        cStatusHomologacao = (item.row.original.A2_MEDIA >= nMediaHomologado ? 'Qualificado' : 'Não Qualificado')
    }

    return cStatusHomologacao
}

const handleInputContato = (item, accessor, header, data, setData, disabledForm) => {
    const chaveFornecedor = item.row.original.A2_COD + item.row.original.A2_LOJA;
  
    let cConsulta = "SELECT TOP 1 '0' U5_CODCONT, 'Novo Contato' U5_CONTAT, '' U5_FONE, '' U5_EMAIL, '' U5_CELULAR FROM TABELA(SU5) UNION ";
    cConsulta += "SELECT U5_CODCONT, U5_CONTAT, U5_FONE, U5_EMAIL, U5_CELULAR FROM TABELA(SU5) SU5 ";
    cConsulta += "LEFT JOIN TABELA(AC8) AC8 ON AC8_FILIAL = U5_FILIAL AND AC8_ENTIDA = 'SA2' AND AC8_CODCON = U5_CODCONT AND AC8_STATUS <> 'I' AND AC8.D_E_L_E_T_ <> '*' ";
    cConsulta += "WHERE SU5.D_E_L_E_T_ <> '*' AND AC8_CODENT = '" + chaveFornecedor + "' ";
    cConsulta += "AND UPPER(U5_CONTAT) <> 'NOVO CONTATO' "
    cConsulta += "ORDER BY U5_CODCONT ";
  
    return (
        <SelectContato
            queryContato={cConsulta}
            bindItem={item} // Passa o item diretamente
            field="CONTATO" // Campo que será atualizado no item
            returnOriginal={true}
            noFilter={true}
            placeholder="Selecione um Contato já existente"
            changeContato={(e) => handleContatoFornecedor(e, item, accessor, header, data, setData)} // Função de mudança
            disabled={disabledForm}
        />
    );
};
  
const handleContatoFornecedor = (e, item, accessor, header, data, setData) => {
    item.row.original.CONTATO = e;
    
    if (e.origem){
        item.row.original.NOME = e.origem.U5_CONTAT.trim();
        item.row.original.EMAIL = e.origem.U5_EMAIL.trim();
        item.row.original.TELEFONE = e.origem.U5_FONE.trim();
        item.row.original.CELULAR = e.origem.U5_CELULAR.trim();
    }

    // Aqui garantimos que os valores vinculados sejam re-renderizados
    item.NOME = e.origem?.U5_CONTAT.trim() || "";
    item.EMAIL = e.origem?.U5_EMAIL.trim() || "";
    item.TELEFONE = e.origem?.U5_FONE.trim() || "";
    item.CELULAR = e.origem?.U5_CELULAR.trim() || "";

    $(`#NOME_${item.A2_COD}_${item.A2_LOJA}`)[0].setAttribute('disabled',true);
    $(`#EMAIL_${item.A2_COD}_${item.A2_LOJA}`)[0].setAttribute('disabled',true);
    $(`#TELEFONE_${item.A2_COD}_${item.A2_LOJA}`)[0].setAttribute('disabled',true);
    $(`#CELULAR_${item.A2_COD}_${item.A2_LOJA}`)[0].setAttribute('disabled',true);

    if (String(item.CONTATO.value.trim()) === '0'){
        $(`#NOME_${item.A2_COD}_${item.A2_LOJA}`)[0].removeAttribute('disabled');
        $(`#EMAIL_${item.A2_COD}_${item.A2_LOJA}`)[0].removeAttribute('disabled');
        $(`#TELEFONE_${item.A2_COD}_${item.A2_LOJA}`)[0].removeAttribute('disabled');
        $(`#CELULAR_${item.A2_COD}_${item.A2_LOJA}`)[0].removeAttribute('disabled');
    }

    handleChangeData(item, data, setData)
};

const handleChangeData = (item, data, setData) => {
    const newData = data.map( (itemData) => { 
        if ( itemData.A2_COD === item.A2_COD && itemData.A2_LOJA === item.A2_LOJA ){
            itemData.CONTATO = item.CONTATO;
            itemData.NOME = item.NOME;
            itemData.EMAIL = item.EMAIL;
            itemData.TELEFONE = item.TELEFONE;
            itemData.CELULAR = item.CELULAR;
        }

        return itemData
    } )

    $(`#NOME_${item.A2_COD}_${item.A2_LOJA}`)[0].value = item.NOME;
    $(`#EMAIL_${item.A2_COD}_${item.A2_LOJA}`)[0].value = item.EMAIL;
    $(`#TELEFONE_${item.A2_COD}_${item.A2_LOJA}`)[0].value = item.TELEFONE;
    $(`#CELULAR_${item.A2_COD}_${item.A2_LOJA}`)[0].value = item.CELULAR;
    
    setData(newData)
}

const handleInputNome = (item, accessor, header, data, setData) => {
    return ( <InputGeral
                idComponente={`NOME_${item.A2_COD}_${item.A2_LOJA}`}
                tipo={"text"}
                bindItem={item}
                field="NOME"
                onChange={(e) => { handleChangeData(item, data, setData) }}
                placeholder="Nome Contato"
                disabled={true}
            />)
}

const handleInputEmail = (item, accessor, header, data, setData) => {
    return ( <InputGeral
                idComponente={`EMAIL_${item.A2_COD}_${item.A2_LOJA}`}
                tipo={"email"}
                bindItem={item}
                field="EMAIL"
                onChange={(e) => { handleChangeData(item, data, setData) }}
                placeholder="E-mail Contato"
                disabled={true}
            />)
}

const handleInputTelefone = (item, accessor, header, data, setData) => {
    return ( <InputGeral
                idComponente={`TELEFONE_${item.A2_COD}_${item.A2_LOJA}`}
                tipo={"text"}
                bindItem={item}
                field="TELEFONE"
                onChange={(e) => { handleChangeData(item, data, setData) }}
                placeholder="Telefone Contato"
                disabled={true}
            />)
}

const handleInputCelular = (item, accessor, header, data, setData) => {
    return ( <InputGeral
                idComponente={`CELULAR_${item.A2_COD}_${item.A2_LOJA}`}
                tipo={"text"}
                bindItem={item}
                field="CELULAR"
                onChange={(e) => { handleChangeData(item, data, setData) }}
                placeholder="Celular Contato"
                disabled={true}
            />)
}

export { handleCardFornecedor, handleHomologacaoLabel, handleCheckColumnFornecedor, handleHomologacao, handleInputContato, handleInputNome, handleInputEmail, handleInputTelefone, handleInputCelular, handleFornecedorCodigo, handleFornecedorTipo, handleFornecedorMunicipio, handleAvaliacao }